import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { NvButtonModule } from 'Src/nvps-libraries/design/nv-button/nv-button.module';
import { NvLogoModule } from 'Src/nvps-libraries/design/nv-logo/nv-logo.module';
import { NvNoteModule } from 'Src/nvps-libraries/design/nv-note/nv-note.module';
import { SharedServicesModule } from '../../shared/services/shared.services.module';
import { LoginComponent } from './login.component';

@NgModule({
  imports: [CommonModule, MatButtonModule, NvButtonModule, NvLogoModule, NvNoteModule, SharedServicesModule],
  declarations: [LoginComponent],
})
export class LoginModule {}
